<button 
    class="card-container" 
    (click)="selectProgram()" 
    [ariaLabel]='(programData.program_name | programNameARIALabelPipe)'
>
    <div class="card-action">
       
        <div class="head">
            <div class="title" >
                {{ programData.program_name}}
            </div>

             
        </div>
        <div class="action">
            <div class="select-text">
                Click to select
            </div>
            <div class="select-arrow">
                <img class="arrow" src="/assets/images/arrow_forward_ios_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24.svg"
                    height="24px" alt="">
            </div>
        </div>
    </div>

</button>